import { Button } from 'antd'
import React from 'react'
import glossariy from '../fayl/GLOSSARIY.pdf'

const Glossariy = () => {
  return (
    <Button className='button'>
        <a href={glossariy}>Glossariy</a>
    </Button>
  )
}

export default Glossariy